/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The breadCrumbs selectors
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IBreadCrumbsState } from './breadCrumbsReducer';
import { IBreadCrumb } from './breadCrumbsTypes';

export const getBreadCrumbs = (state: IRootReducer): IBreadCrumbsState => state.breadCrumbs;

export const makeSelectBreadCrumbsData = (): OutputSelector<IRootReducer, IBreadCrumb[], (state: IBreadCrumbsState) =>
    IBreadCrumb[]> =>
    createSelector(
        getBreadCrumbs,
        state => state.data,
    );
